import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fetchAnnouncements,
  fetchPromotions,
  fetchInventories,
  fetchExpiringItems,
  fetchUnsalableItems,
  fetchNotifications
} from '../../app/actions'
import {
  setI13nData,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../app/actions/common'
import Warehouse from '../components/Warehouse/Warehouse'

const mapStateToProps = (state, ownProps) => {
  return {
    i13nData: state.page.i13nData,
    supplier: state.supplier,
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setI13nData,
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    setI13nData,
    fetchAnnouncements,
    fetchPromotions,
    fetchInventories,
    fetchExpiringItems,
    fetchUnsalableItems,
    fetchNotifications
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

Warehouse.fetchData = ({ store, req, res }) => {
  const tasks = [
    // // 取得右方及上方宣傳版位上稿
    // APACSMDESK-20096 先關閉資料
    // store.dispatch(supplierActions.fetchPromotions({ id: ['SpHeaderTxt1', 'SpHomeRightImg1'] }))
  ]
  return Promise.all(tasks)
}

const MappedWarehouse = connect(
  mapStateToProps,
  mapDispatchToProps
)(Warehouse)

export default MappedWarehouse
